import { NoItemFoundCard } from './styles';

const NoItemFound: React.FC<{text: string, show: boolean}> = ({text, show}) => {
    return (
        show ? (
        <NoItemFoundCard>
            <span color='black'><b>{text}</b></span>
        </NoItemFoundCard>
        ) : (<></>)
    );
}

export default NoItemFound;